import React, { useState } from 'react';
import { Box } from '@mui/material';
import { KeyboardArrowRight as ArrowRightIcon } from '@mui/icons-material';

import SidebarLeft from './SidebarLeft';
import { PageTitleProvider } from './PageTitleContext';
import { setSidebarState } from '../hooks/useSidebarState';
import GlobalLoadingBackdrop from '../components/GlobalLoadingBackdrop';
import RouteChangeCleanup from '@/__core/navigation/RouteChangeCleanup';


interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <PageTitleProvider>
      <MainLayoutContent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}>
        {children}
      </MainLayoutContent>
    </PageTitleProvider>
  );
};

const MainLayoutContent: React.FC<MainLayoutProps & { sidebarOpen: boolean; setSidebarOpen: (open: boolean) => void }> = ({ children, sidebarOpen, setSidebarOpen }) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <RouteChangeCleanup />
      {/* Sidebar */}
      <SidebarLeft 
        open={sidebarOpen} 
        onToggle={(open) => {
          setSidebarOpen(open);
          setSidebarState(open);
        }}
      />

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Top Header */}
        {/* <Header sidebarOpen={sidebarOpen} onToggleSidebar={setSidebarOpen} /> */}
        
        {/* Toggle Button when sidebar is closed */}
        {!sidebarOpen && (
          <Box
            component="button"
            onClick={() => {
              setSidebarOpen(true);
              setSidebarState(true);
            }}
            sx={{
              position: 'fixed',
              top: 80,
              left: 0,
              zIndex: 1200,
              backgroundColor: '#1e3a8a',
              color: 'white',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              borderRadius: '0 4px 4px 0',
              width: 20,
              height: 34,
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 2px',
              '&:hover': {
                backgroundColor: '#1e40af',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              },
              '& svg': {
                fontSize: '0.75rem',
              },
            }}
          >
            <ArrowRightIcon />
          </Box>
        )}
        
        {/* Content Area */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: 'white',
          }}
        >
          {children}
        </Box>
      </Box>
      
      {/* Global Loading Backdrop */}
      <GlobalLoadingBackdrop />
    </Box>
  );
};

export default MainLayout; 